import "core-js/modules/es6.string.from-code-point";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import sizePropTypes from '../../prop-types/Size';
import styles from './CountryIcon.css';
var cx = classnames.bind(styles);
var FLAGS = {
  USA: "".concat(String.fromCodePoint(0x1F1FA)).concat(String.fromCodePoint(0x1F1F8)),
  CAN: "".concat(String.fromCodePoint(0x1F1E8)).concat(String.fromCodePoint(0x1F1E6)),
  AUS: "".concat(String.fromCodePoint(0x1F1E6)).concat(String.fromCodePoint(0x1F1FA))
};
export default function CountryIcon(_ref) {
  var countryCode = _ref.countryCode,
      className = _ref.className,
      size = _ref.size;
  var flag = FLAGS[countryCode];
  return React.createElement("span", {
    className: cx('icon', className, size)
  }, flag);
}
CountryIcon.propTypes = {
  /** country code for which the flag to be displayed */
  countryCode: PropTypes.oneOf(['USA', 'CAN', 'AUS']).isRequired,

  /** Class name to apply to component */
  className: PropTypes.string,

  /** String that represents size of icon */
  size: sizePropTypes
};
CountryIcon.defaultProps = {
  className: undefined,
  size: undefined
};